import React, { useEffect } from 'react';
import DocGridYAxisData from './components/DocGridYAxisData'
import DocGridXAxisData from './components/DocGridXAxisData'
import DocGridYStatData from './components/DocGridYStatData';
import searchViewMap from './Index';
import DocGridXYAxisData from './components/DocGridXYAxisData';
import SarasTrans from '../../../library/notifications/SarasTrans';

const DocXYGridContainer = (props)=>{
    const {viewData, onSearchRequest, reloadSearch, rowSelector, recalculateParameters, setRecalculateParameters} = props;
    const [xGridSize, setXGridSize] = React.useState(null);

    const xAxisView  = React.useRef();
    const xyAxisView  = React.useRef();

    // const topScroll = React.createRef();
    const sidebarScroll1 = React.createRef();
    const sidebarScroll2 = React.createRef();
    const contentScroll = React.createRef();

    // var _contentScrolling = false;
    // var _sidebar1Scrolling = false;
    // var _sidebar2Scrolling = false;
    // var contentLastScrollTop = 0;
    // var contentLastScrollLeft = 0;

    // const onTopScroll = e => {
    //   if (_preventEvent) {
    //     _preventEvent = false;
    //     return;
    //   }
  
    //   console.log("onTopScroll", e.target.scrollTop, e.target.scrollLeft);
  
    //   _preventEvent = true;
    //   contentScroll.current.scrollLeft = e.target.scrollLeft;
    // };
  
    const onSidebar1Scroll = e => {
      // if (_preventEvent) {
      //   _preventEvent = false;
      //   return;
      // }
  
      // console.log("onSidebarScroll", e.target.scrollTop, e.target.scrollLeft);
  
      // _sidebar1Scrolling = true;
      // contentLastScrollTop = e.target.scrollTop;

      if (e.target.scrollTop !== sidebarScroll2.current.scrollTop) {
        sidebarScroll2.current.scrollTop = e.target.scrollTop;
      }

      if (e.target.scrollTop !== contentScroll.current.scrollTop) {
        contentScroll.current.scrollTop = e.target.scrollTop;
      }
      
    };

    const onSidebar2Scroll = e => {
      // if (_contentScrolling) {
      //   _preventEvent = false;
      //   return;
      // }
  
      // console.log("onSidebarScroll", e.target.scrollTop, e.target.scrollLeft);
  
      // _sidebar2Scrolling = true;
      // contentLastScrollTop = e.target.scrollTop;

      if (e.target.scrollTop !== sidebarScroll1.current.scrollTop) {
        sidebarScroll1.current.scrollTop = e.target.scrollTop;
      }
      
      if (e.target.scrollTop !== contentScroll.current.scrollTop) {
        contentScroll.current.scrollTop = e.target.scrollTop;
      }
    };
  
    const onContentScroll = e => {
      // if (_preventEvent) {
      //   _preventEvent = false;
      //   return;
      // }
      // console.log("onContentScroll", e.target.scrollTop, e.target.scrollLeft);
  
      // if (e.target.scrollTop !== contentLastScrollTop) {
        // _contentScrolling = true;

      if (e.target.scrollTop !== sidebarScroll1.current.scrollTop) {
        sidebarScroll1.current.scrollTop = e.target.scrollTop;
        // contentLastScrollTop = e.target.scrollTop;
      }
      
      if (e.target.scrollTop !== sidebarScroll2.current.scrollTop) {
        sidebarScroll2.current.scrollTop = e.target.scrollTop;
        // contentLastScrollTop = e.target.scrollTop;
      }
        
      // }
      // if (e.target.scrollLeft !== contentLastScrollLeft) {
      //   _preventEvent = true;
      //   topScroll.current.scrollLeft = e.target.scrollLeft;
      //   contentLastScrollLeft = e.target.scrollLeft;
      // }
    };

    // console.log("xygriddata", viewData.childViews.statsValueView);

    const xSizeCalculator = () => {
      // console.log("xygrid, recalculate", xGridSize);
      if (xAxisView.current && recalculateParameters === 1) {
          let xheight = document.documentElement.clientHeight
            - (xyAxisView.current.offsetTop + xyAxisView.current.offsetParent.offsetTop)
            - 35;

          //get the count of li uiXGridCell in the ul uiXGridList
          let xGridCells = xAxisView.current.getElementsByClassName("uiXGridHeaderCell");

          let xGridCellsLength = xGridCells.length;

          if(xGridCellsLength < 5) xGridCellsLength = 5; //default to 5 if no cells found

          //get the width of the first li
          let xGridCellWidth = (xGridCells[0] && xGridCells[0].offsetWidth) || 200;

          //multiple the width of the first li with the count and set it as total width
          let xGridSizeNew =
                    {width: ((xGridCellsLength || 5) * xGridCellWidth) + 10,
                    height: xheight};

          // console.log("varun xygrid grid size new", xGridSizeNew, "count of group", xGridCells.length, 
          // "document clientHeight", document.documentElement.clientHeight,
          // "scrollTop", document.documentElement.scrollTop, 
          // "scrollHeight", document.documentElement.scrollHeight, 
          // "xaxisview div rect", xAxisView.current.getBoundingClientRect(),
          // "offsetTop", xyAxisView.current.offsetTop,
          // "offsetParent.offsetTop", xyAxisView.current.offsetParent.offsetTop);

          setRecalculateParameters(0);
          setXGridSize(xGridSizeNew);
      }
  };

  const xResetCalculator = () => {
    setRecalculateParameters(1);
    // console.log("xygrid, reset", xGridSize);
    // xSizeCalculator();
  }

  useEffect(() => {
    window.addEventListener('resize', xResetCalculator);

    // clean up function
    return () => {
      // remove resize listener
      window.removeEventListener('resize', xResetCalculator);
    }
    
});

useEffect(() => {
  xSizeCalculator();
});

const getYTitle = () => {
  var title;

  if(viewData && viewData.dataList)
      title = viewData.dataList.gridTitle;

  return title;
}

const getStatTitle = () => {
  var title;

  if(viewData.childViews.statsValueView && viewData.childViews.statsValueView.dataList)
      title = viewData.childViews.statsValueView.dataList.gridTitle;

  return title;
}

var yTitle = getYTitle();
var statTitle = getStatTitle();

  return(
    <div className="uiSecContents uiXYGridContainer">
      <div className='uiFlexDistributedNoWrap'>
        <div className="uiXYGridColumn1">
          <div className='uiXYGridXRowHeight uiXYTitle'>
            <span className='uiBlock'><SarasTrans value={yTitle} /></span>
          </div>
          <div style={{minHeight:`${xGridSize ? xGridSize.height : 100}px`}} className='uiXYGridYRowSection'>
            <DocGridYAxisData xGridSize={xGridSize} viewData={viewData} 
              viewMap={searchViewMap} rowSelector={rowSelector} 
              reloadSearch={reloadSearch} sidebarScroll={sidebarScroll1}
              onSidebarScroll={onSidebar1Scroll}>
            </DocGridYAxisData>
          </div>
        </div>
        <div className="uiXYGridColumn2">
          <div className='uiXYGridXRowHeight uiXYTitle'>
            <span className='uiBlock'><SarasTrans value={statTitle} /></span>
          </div>
          <div style={{minHeight:`${xGridSize ? xGridSize.height : 100}px`}} className='uiXYGridYRowSection'>
            <DocGridYStatData xGridSize={xGridSize} viewData={viewData.childViews.statsValueView} 
              viewMap={searchViewMap} rowSelector={rowSelector} reloadSearch={reloadSearch} 
              sidebarScroll={sidebarScroll2} onSidebarScroll={onSidebar2Scroll}>
            </DocGridYStatData>
          </div>
        </div>
        <div className="uiXYGridColumn3">
          <div ref={xAxisView} className="uiXYGrid" style={{overflow:"scroll"}}>
              <div style={{width:`${xGridSize ? xGridSize.width : 100}px`}} >
                <div className='uiXYGridXRowHeight uiXYColumn3Title'>
                  <DocGridXAxisData xGridSize={xGridSize} viewData={viewData.childViews.xAxisView} 
                    onSearchRequest={onSearchRequest} viewMap={searchViewMap} rowSelector={rowSelector} 
                    reloadSearch={reloadSearch}>
                  </DocGridXAxisData>
                </div>
                <div ref={xyAxisView} style={{minHeight:`${xGridSize ? xGridSize.height : 100}px`}} className='uiXYGridValueSection' >
                  <DocGridXYAxisData xGridSize={xGridSize} viewData={viewData.childViews.xyValueView} 
                    onSearchRequest={onSearchRequest} viewMap={searchViewMap} rowSelector={rowSelector} 
                    reloadSearch={reloadSearch} contentScroll={contentScroll} onContentScroll={onContentScroll}>
                  </DocGridXYAxisData>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DocXYGridContainer